import React from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import { useState } from "react";

import { currencyFormat, formatCalendarDate, formatDateForPanelDisplay } from "../../Utils/helper";
import "./CostRow.css";
import api from "../../api/api";
import { useDocumentModal } from "../common/CustomModal/CustomModalContext";
import UserChatBubble from "../Forms/FirmUserBtn";
import ChequeUpload from "../SettlementDashboard/ChequeUpload";

import { useCheckRequestModal } from "./CheckRequestModalContext";
import { useAlertCheckNotRequestedModal } from "./AlertCheckNotRequestedModalContext";
import { useCostManagement } from "./CostManagementContext";
import { useUpdateTrigger } from "./TriggerUpdateContext";
import { invoiceIconDetails } from "./IconDetails";
// import avatarImage from "./../../../assets/images/avatar.svg";
import CheckAlreadyRequestedModal from "./CheckAlreadyRequested";

const RequestCheckButton = ({ cost, showModal }) => (
  <button
    style={{
      boxSizing: "border-box",
      fontSize: "14px",
      paddingTop: "0px",
      paddingBottom: "0px",
      paddingLeft: "5px",
      paddingRight: "5px",
      height: "25px",
      backgroundColor: "var(--primary)",
      color: "white",
      display: "flex",
      alignItems: "center",
      margin: "auto",
    }}
    type="button"
    onClick={(e) => {
      e.stopPropagation();
      showModal({
        clientId: cost.for_client,
        caseId: cost.for_case,
        costId: cost.id,
        payee: cost.payee,
        amount: cost.amount,
        invoice_number: cost.invoice_number,
        memo: cost.memo,
      });
    }}
  >
    Request Check
  </button>
);

const StyledTableCell = ({ children, className, ...props }) => (
  <td id="padding-adding-5px" className={`cost-cell ${className || ""}`} {...props}>
    {children}
  </td>
);

async function uploadAndAttachDocument(
  acceptedFiles,
  cost,
  slotDetails,
  toggleTriggerUpdate,
  documentType = "invoice"
) {
  if (!acceptedFiles.length) return; // Ensure there's at least one file to upload

  const formData = new FormData();
  formData.append("file0", acceptedFiles[0]);
  formData.append("number_of_files", 1);

  formData.append("client_id", cost.for_client);
  formData.append("case_id", cost.for_case);

  try {
    const uploadResponse = await api.post("/api/upload/doc/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    const attachData = {
      doc_id: uploadResponse.data?.docId || "",
      page_id: slotDetails?.page?.id || "",
      case_id: cost.for_case || "",
      document_type: documentType,
    };

    const attachResponse = await api.post(`/api/attach-document/${cost.id}/`, attachData, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    toggleTriggerUpdate();
    return attachResponse.data;
  } catch (error) {
    console.error("Error in file upload or document attachment", error);
    throw error;
  }
}

const CostTableRow = ({ cost, slotDetails, idx = 0, trRef, rowHeight }) => {
  const { showDocumentModal } = useDocumentModal();
  const { toggleTriggerUpdate } = useUpdateTrigger();
  const { showModal: showCheckRequestModal } = useCheckRequestModal();
  const { showModal: showAlertCheckNotRequestedModal } = useAlertCheckNotRequestedModal();
  const { showModal: showEditCostModal } = useCostManagement();
  const userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);
  const [checkAlreadyRequested, setCheckAlreadyRequested] = useState(false);
  const onDropInvoice = React.useCallback((acceptedFiles, e) => {
    uploadAndAttachDocument(acceptedFiles, cost, slotDetails, toggleTriggerUpdate, "invoice")
      .then(() => {})
      .catch((err) => console.error(err));
    e.stopPropagation();
  }, []);

  const {
    getRootProps: getRootPropsInvoice,
    getInputProps: getInputPropsInvoice,
    open: openInvoice,
  } = useDropzone({
    onDrop: onDropInvoice,
    noClick: true,
  });

  const renderInvoiceUploadIcon = (iconDetails) => {
    const { url, alt } = iconDetails;
    return (
      <div
        {...getRootPropsInvoice()}
        style={{ width: "25px" }}
        onClick={(e) => {
          e.stopPropagation();
          openInvoice();
        }}
      >
        <input {...getInputPropsInvoice()} />
        <img src={url} alt={alt} className="height-i-25 gray-scale-1 dz-clickable" />
      </div>
    );
  };
  return (
    <>
      <tr
        ref={trRef}
        style={{
          height: `${rowHeight}px`,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        }}
        className="cost-row"
        onClick={() => {
          if (cost?.checkID) {
            setCheckAlreadyRequested(true);
          } else {
            showEditCostModal(cost, true);
          }
        }}
      >
        <StyledTableCell
          style={{
            color: "var(--primary-25)",
            fontWeight: "600",
          }}
          className={"td-autosize"}
        >
          {idx + 1}
        </StyledTableCell>
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"td-autosize"}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={
              {
                // gap: "5px",
              }
            }
          >
            <div>{formatDateForPanelDisplay(cost?.date_requested)}</div>
            <div className="d-flex align-items-center justify-content-center">
              <UserChatBubble
                userId={cost?.creating_user?.id}
                first_name={cost?.creating_user?.first_name ?? ""}
                last_name={cost?.creating_user?.last_name ?? ""}
                profilePic={cost?.creating_user?.profile_pic ?? ""}
                is_active={cost?.creating_user?.is_active}
                width={19}
                isActive={userOnlineStatus?.[cost?.creating_user?.id]?.isOnline ?? false}
              />
            </div>
          </div>
        </StyledTableCell>
        <td />
        {/* Payee */}
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"td-autosize align-left text-start  p-x-10"}
        >
          <div
            style={{
              paddingRight: "5px",
            }}
          >
            <div>{cost?.payee}</div>
            <div className="d-flex align-items-start flex-column">
              <span>
                {cost?.payee_contact?.address1} {cost?.payee_contact?.address2}
              </span>
              <span>
                {cost?.payee_contact?.city} {cost?.payee_contact?.state} {cost?.payee_contact?.zip}
              </span>
            </div>
          </div>
        </StyledTableCell>
        <td />
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"align-left text-center white-space-no td-autosize  p-x-10"}
        >
          <div
            style={{
              paddingRight: "5px",
            }}
          >
            {cost.memo}
          </div>
        </StyledTableCell>
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"align-left text-center white-space-no td-autosize  p-x-10"}
        >
          <div
            style={{
              paddingRight: "5px",
            }}
          >
            {cost.note}
          </div>
        </StyledTableCell>
        <td />
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"td-autosize align-left  p-x-10"}
        >
          {cost.bank_account ? `Bank Account: ${cost.account_number}` : ""}
        </StyledTableCell>
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"td-autosize align-left  text-end p-x-10"}
        >
          <div
            className="d-flex align-items-center justify-content-end"
            style={{
              gap: "5px",
            }}
          >
            {cost.invoice_number}
            <div className="d-flex align-items-center justify-content-center">
              {cost.document ? (
                <img
                  src={invoiceIconDetails.checkUploadedIcon.url}
                  alt={invoiceIconDetails.checkUploadedIcon.alt}
                  className="height-i-25"
                  onClick={(e) => {
                    e.stopPropagation();

                    showDocumentModal("document", cost.document.upload, cost.document);
                  }}
                />
              ) : (
                renderInvoiceUploadIcon(invoiceIconDetails.checkUploadIcon)
              )}
            </div>
          </div>
        </StyledTableCell>

        <td />
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"monospace-font text-end td-autosize align-left "}
        >
          <p
            style={{
              fontWeight: 600,
              color: cost.amount === 0 ? "var(--primary-40)" : "#000",
              // width: "111.15px",
              // minWidth: "111.15px",
            }}
          >
            {currencyFormat(cost.amount)}
          </p>
        </StyledTableCell>
        <StyledTableCell
          style={{
            fontWeight: "600",
          }}
          className={"monospace-font text-center td-autosize align-left "}
        >
          {cost?.paid_by === "Credit Card" && (
            <div style={{ fontWeight: 600 }}>
              {cost?.paid_by === "Credit Card" && (
                <span>{cost?.credit_card ? `CC: ${cost.card_number}` : ""}</span>
              )}
            </div>
          )}
          {cost?.paid_by === "Check" && (
            <>
              {cost.checkID?.cheque_number || cost.checkID?.date_requested ? (
                <>
                  <StyledTableCell style={{ fontWeight: "600" }}>
                    <div
                      className="d-flex align-items-center"
                      style={{
                        gap: "5px",
                      }}
                    >
                      <p style={{ textAlign: "left" }}>
                        {formatCalendarDate(cost.checkID.date_requested)}
                      </p>
                      <div className="d-flex align-items-center justify-content-center">
                        <ChequeUpload
                          entity={cost}
                          panel="cost"
                          pageId={slotDetails?.page?.id}
                          documentType="check_as_sent"
                          updateStates={toggleTriggerUpdate}
                          handleNoCheckShow={showAlertCheckNotRequestedModal}
                          width="max-content"
                        />
                      </div>
                      <div className="d-flex align-items-center justify-content-center">
                        <ChequeUpload
                          entity={cost}
                          panel="cost"
                          pageId={slotDetails?.page?.id}
                          documentType="check_cleared"
                          updateStates={toggleTriggerUpdate}
                          handleNoCheckShow={showAlertCheckNotRequestedModal}
                          width="max-content"
                        />
                      </div>
                    </div>
                  </StyledTableCell>
                </>
              ) : (
                <StyledTableCell style={{ fontWeight: "600" }}>
                  <div className="flex justify-content-center align-items-center">
                    <RequestCheckButton cost={cost} showModal={showCheckRequestModal} />
                  </div>
                </StyledTableCell>
              )}
            </>
          )}
        </StyledTableCell>
        <td
          style={{
            minWidth: "15px",
            width: "15px",
            maxWidth: "15px",
          }}
        />
      </tr>
      {checkAlreadyRequested && (
        <>
          <CheckAlreadyRequestedModal
            show={checkAlreadyRequested}
            hideModal={() => setCheckAlreadyRequested(false)}
          />
        </>
      )}
    </>
  );
};

export default React.memo(CostTableRow);
